"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WLoadingImage = WLoadingImage;
var _react = _interopRequireDefault(require("react"));
var _oneWeir = require("@weirgroup/one-weir");
var _main = _interopRequireDefault(require("./main.css"));
function WLoadingImage(props) {
  return /*#__PURE__*/_react.default.createElement("div", null, props.isLoading && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_main.default.loading)
  }, /*#__PURE__*/_react.default.createElement(_oneWeir.SpinnerCircular, null)));
}